import React from 'react';
import Radium from 'radium';
import StylePropType from 'react-style-proptype';
import Spinner from 'react-spinkit';
import Styles from './styles';

const LoadingOverlay = props => (
  <div style={[Styles.wrapper, props.style]}>
    <Spinner name="ball-triangle-path" color={Styles.spinnerColor} fadeIn="none" />
  </div>
);

LoadingOverlay.propTypes = {
  style: StylePropType,
};

export default Radium(LoadingOverlay);



// WEBPACK FOOTER //
// ./src/components/LoadingOverlay/index.js